export default __webpack_public_path__ + "static/media/ico-boleto.a0bf708e.svg";